import isValidMobileNumber from '../../../features/auth/utils/isValidMobileNumber'
import { emailValidation } from '../../../utils/validations'

export default function isSignupFormValid({
	name,
	mobileNumber,
	email,
	countryPhoneCode,
}) {
	return (
		!!name &&
		emailValidation(email) &&
		mobileNumber &&
		isValidMobileNumber(`${countryPhoneCode}${mobileNumber}`)
	)
}
